export function Semaphore(maxParalellTasks) {
  var currentParalellTasks = 0;
  var waitingTasks = [];

  /**
   * resolves the current task
   */
  var take = function () {
    if (waitingTasks.length > 0 && currentParalellTasks < maxParalellTasks) {
      currentParalellTasks++;
      let promise = waitingTasks.shift();
      promise.resolve();
    }
  };

  /**
   * releases the current "thread"
   */
  this.release = function () {
    currentParalellTasks--;
    take();
  };

  /**
   * locks the current "thread"
   * @returns unresolved promise
   */
  this.lock = function () {
    if (currentParalellTasks < maxParalellTasks) {
      currentParalellTasks++;

      return new Promise((resolve) => {
        resolve();
      });
    } else {
      return new Promise((resolve, error) => {
        waitingTasks.push({resolve: resolve, error: error});
      });
    }
  };

  /**
   * kills all unresolved tasks
   * @returns killed unresolved tasks
   */
  this.purge = function () {
    let unresolved = waitingTasks.length;

    for (let i = 0; i < unresolved; i++) {
      waitingTasks[i].err("Task has been purged.");
    }

    currentParalellTasks = 0;
    waitingTasks = [];

    return unresolved;
  };
}